var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { containerStaticStyle, loaderPathStaticStyle, loaderSvgStyle, svgWrapperStaticStyle, wrapperStyle, } from './styles';
function Loader(_a) {
    var ariaLabel = _a["aria-label"], _b = _a.inverted, inverted = _b === void 0 ? false : _b, restProps = __rest(_a, ['aria-label', "inverted"]);
    var height = restProps.height, width = restProps.width;
    return (_jsx("div", __assign({ "aria-label": ariaLabel, css: wrapperStyle({ height: height, width: width }), "data-testid": "loader-wrapper", role: "alert" }, { children: _jsx("div", __assign({ css: containerStaticStyle }, { children: _jsx("div", __assign({ css: svgWrapperStaticStyle }, { children: _jsx("svg", __assign({ css: loaderSvgStyle({ inverted: inverted }), viewBox: "0 0 2640 3444" }, restProps, { children: _jsx("path", { css: loaderPathStaticStyle, d: "M0 0 M2569 1056L143 2447V149l1175 673v1867l1248 715", fill: "none", strokeLinejoin: "round", strokeWidth: "300" }) })) })) })) })));
}
export default Loader;
